import { render, staticRenderFns } from "./sdg-item.vue?vue&type=template&id=4f8a065c&scoped=true&"
import script from "./sdg-item.vue?vue&type=script&lang=js&"
export * from "./sdg-item.vue?vue&type=script&lang=js&"
import style0 from "./sdg-item.vue?vue&type=style&index=0&id=4f8a065c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8a065c",
  null
  
)

export default component.exports